import { Routes } from '@angular/router';
import { PageKey } from '../../../shared/services/page/models/page.key';
import { canActivate } from '../../../shared/guard/guard';
import { HeaderEnum, PermissionEnum } from '../../../../environments/shared-environment/permission';

export const documentsComparisonRoute: Routes = [{
  path: 'documents/comparison',
  canActivateChild: [() => canActivate(HeaderEnum.DOCS_COMPARE, PermissionEnum.VIEW)],
  loadComponent: () => import('./documents-comparison.component').then(m => m.DocumentsComparisonComponent),
  children: [
    {
      path: '',
      loadComponent: () => import('./compare/compare.component').then(m => m.CompareComponent),
      data: {
        title: 'Comparar Documentos',
        key: PageKey.COMPARISON
      },
    },

    {
      path: 'compare',
      loadComponent: () => import('./compare/compare.component').then(m => m.CompareComponent),
      data: {
        title: 'Comparar Documentos',
        key: PageKey.COMPARISON
      },
    },

    {
      path: 'my-comparisons',
      loadComponent: () => import('./user-comparisons/user-comparisons.component').then(m => m.UserComparisonsComponent),
      data: {
        title: 'Minhas Comparações',
        key: PageKey.COMPARISON
      },
    },

    {
      path: 'compare/results',
      loadComponent: () => import('./results/results.component').then(m => m.ResultsComponent),
      data: {
        title: 'Resultado',
        key: PageKey.COMPARISON,
        fullscreen: true
      },
    },
  ]
}];
